import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WeightTrackingDependencies} from '../dependencies';
import {keys} from './keys';

export type GetLatestWeightQueryDependencies = Pick<WeightTrackingDependencies, 'controllers'>;

export const getLatestWeightQuery = ({controllers}: GetLatestWeightQueryDependencies) =>
  queryOptions({
    queryKey: keys.latest(),
    queryFn: () => controllers.weightTrackingController.getLatest().then(unwrap),
  });
